import ListActionConfirmationDialog from './ListActionConfirmationDialog'

export default ListActionConfirmationDialog
